import PropTypes from 'prop-types';
import React from 'react';
import querystring from 'querystring';
import { deprecate } from 'react-is-deprecated';

/**
 *  Displays KBB dealer ratings
 *
 */
function IframeKBBDealerRatings(_ref) {
  let {
    height,
    owner: {
      id,
      rating: {
        value,
        apiKey,
        apiUrl
      } = {}
    } = {},
    showCount = false,
    widgetType = 'large',
    width,
    ...rest
  } = _ref;
  if (!value) return null;
  const params = {
    apiKey,
    svocId: id,
    nocount: showCount
  };
  const urlParams = querystring.stringify(params);
  const source = `${apiUrl}/widget/ratings/${widgetType}?` + urlParams;
  return /*#__PURE__*/React.createElement("iframe", Object.assign({
    "data-cmp": "IframekbbDealerRatings",
    title: 'IframekbbDealerRatings-' + id,
    width: width || 270,
    height: height || 250,
    className: "border-0",
    src: source
  }, rest));
}
export default IframeKBBDealerRatings;